import { FormattedMessage as FM } from "react-intl";

import { getContrastText } from "../helpers/colors";
import { hideImage } from "../helpers/images";

function PreviewHero({ image, title, colors }) {
  const primary = colors.primary_color;
  return (
    <div
      className="relative flex h-28 items-end overflow-hidden p-3"
      style={{ backgroundColor: primary, color: getContrastText(primary) }}
    >
      {image && (
        <img
          src={image}
          alt=""
          onError={hideImage}
          className="absolute inset-0 size-full object-cover"
        />
      )}
      {image && (
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
      )}
      <div className={image ? "relative text-white" : "relative"}>
        <span
          className="mb-1 block h-0.5 w-6"
          style={{ backgroundColor: colors.secondary_color }}
        />
        <p className="line-clamp-2 text-sm font-semibold leading-tight">
          {title || <FM id="melhous.dash.preview.hero" />}
        </p>
      </div>
    </div>
  );
}

export default PreviewHero;
